import { PropsWithChildren } from 'react';
import { CoreConfig } from '@/configs/core/core.config';
import useCoreConfig from '@/hooks/use-core-config';

type Props = PropsWithChildren<{
  feature: keyof CoreConfig['features'];
}>;

const FeatureFlag = ({ feature, children }: Props) => {
  const { features } = useCoreConfig();

  if (features[feature]) {
    return children;
  }

  return null;
};

export default FeatureFlag;
